import Reflux from 'reflux';

let PreferencesActions = Reflux.createActions([
  'loadInitialState',
  'hideSidebar',
  'showSidebar',
]);

export default PreferencesActions;



// WEBPACK FOOTER //
// ./app/actions/preferencesActions.jsx